document.addEventListener('DOMContentLoaded',()=>{
  const menuBtn=document.querySelector('.bn-menu-btn');

  const paymentButtons = document.querySelectorAll('.bn-payment-btn');
  const pricingCards = document.querySelectorAll('.bn-pricing .bn-card');

  paymentButtons.forEach(button => {
    button.addEventListener('click', () => {
      const annual = button.dataset.payment === 'annual';

      paymentButtons.forEach(btn => {
        btn.classList.toggle('active', btn === button);
      });

      pricingCards.forEach(card => {
        const price = card.querySelector('.bn-price');
        const seasonPrice = card.querySelector('.bn-season-price');

        if (!price || !seasonPrice) return;

        if (!card.dataset.monthlyHtml) {
          card.dataset.monthlyHtml = price.innerHTML;
          card.dataset.seasonHtml = seasonPrice.innerHTML;
        }

        if (annual) {
          const annualPrice = seasonPrice.textContent.match(/[\d]+[,.][\d]{2}/);
          if (!annualPrice) return;
          price.innerHTML = annualPrice[0] + ' $ <span>/saison</span>';
          seasonPrice.style.display = 'none';
        } else {
          price.innerHTML = card.dataset.monthlyHtml;
          seasonPrice.style.display = 'none';
        }
      });
    });
  });

  const mobile=document.querySelector('.bn-mobile-menu');
  if(menuBtn&&mobile){menuBtn.addEventListener('click',()=>{const open=menuBtn.getAttribute('aria-expanded')==='true';menuBtn.setAttribute('aria-expanded',String(!open));mobile.hidden=open;});}

  const form=document.querySelector('[data-booking-form]');
  if(!form)return;
  const plan=form.querySelector('[data-plan]');
  const bins=form.querySelector('[data-bins]');
  const total=form.querySelector('[data-total]');
  const params=new URLSearchParams(location.search);
  const incoming=params.get('plan');
  if(incoming && [...plan.options].some(o=>o.value===incoming)) plan.value=incoming;
  function calc(){
    const bases={essentiel:20,premium:25,unitaire:45,commercial:0};
    if(plan.value==='commercial'||bins.value==='7plus'){total.textContent='Sur soumission';return;}
    const n=Number(bins.value);const extra=Math.max(0,n-2)*5;const price=bases[plan.value]+extra;
    total.textContent=price+' $'+(plan.value==='unitaire'?' + taxes':'/mois + taxes');
  }
  plan.addEventListener('change',calc);bins.addEventListener('change',calc);calc();
  form.addEventListener('submit',(e)=>{
    e.preventDefault();
    if(plan.value==='commercial'||bins.value==='7plus'){location.href='/pages/commercial';return;}
    alert("La réservation visuelle est prête. Pour encaisser réellement dans Shopify, il faut maintenant créer les produits/variantes et connecter l'application d'abonnement.");
  });
});
